import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any;

@Component({
	selector: 'app-contact',
	templateUrl: './contact.component.html',
	styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

	patronsList: any = "";
	contactList: any = "";
	bannerrequest: any = {};
	bannerList: any = "";

	constructor(private allpagesService: AllPageService,) { }

	ngOnInit() {

		this.loadBanner();
		this.allpagesService.getClubContactpatrons().then((data) => {
			this.patronsList = data;

		});

		this.allpagesService.getClubContact().then((data) => {
			this.contactList = data;

		});

		jQuery(".courses-name").click(function () {
			if (jQuery(this).hasClass('active')) {
				// do nothing
			} else {
				var tabid = jQuery(this).attr('id');
				jQuery(".courses-name").removeClass('active');
				jQuery(this).addClass('active');
				jQuery(".course-main-content").removeClass('active');
				jQuery("#" + tabid + "-content").addClass("active");
			}
			return false;
		});
	}
	loadBanner() {
		this.bannerrequest = {
			title: 'Contact Us'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			//console.log(this.bannerList);
		});
	}

}
